import { myAxios } from "../../utils/serverContextPath";

export const getStatutById = (id) => {
  return myAxios.get(`statut/getbyid/${id}`);
};

export const getStatutAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("statut/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getAllStatut = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("statut/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};

export const deleteStatut = (id) => {
  return myAxios.delete(`statut/delete/${id}`);
};

export const postStatut = (data) => {
  return myAxios.post("statut/save/insert", data);
};

export const updateStatut = (data) => {
  return myAxios.post("statut/save/Update", data);
};

export const findSimilarStatut = (
  keyword,
  tauxsimilarity = 0.8,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("statut/similarity", {
    params: {
      keyword,
      tauxsimilarity,
      sortList,
      sortOrder,
    },
  });

}